import { GroupLessonContainer, GroupLessonCurrentName } from "./GroupLesson.styled";
import { GrandChartMyDayStore } from "../../../../../stores/grand-charts/grand-charts-my-day/grand-chart-my-day.store";
import { useTranslation } from "react-i18next";

interface GroupLessonProps {
	grandChartMyDayStore: GrandChartMyDayStore;
}

export const GroupLesson = ({ grandChartMyDayStore }: GroupLessonProps) => {
	const { t } = useTranslation();

	return (
		<GroupLessonContainer>
			{t("titles.lesson_group")} :{" "}
			<GroupLessonCurrentName>{grandChartMyDayStore.lastLessonData?.name_group_lesson}</GroupLessonCurrentName>
		</GroupLessonContainer>
	);
};
